import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import {
  selectInsightsByDocument,
  selectInsightsError,
  selectInsightsLoading,
} from "../store/insightsSelectors";
import { InsightItem } from "./InsightItem";

interface InsightListProps {
  documentId: string;
}

export const InsightList: React.FC<InsightListProps> = ({ documentId }) => {
  const insights = useSelector(selectInsightsByDocument(documentId));
  const loading = useSelector(selectInsightsLoading);
  const error = useSelector(selectInsightsError);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  if (!insights.length) {
    return (
      <Box p={2}>
        <Typography color="text.secondary">No insights found</Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2} pt={2}>
      {insights.map((insight) => (
        <InsightItem key={insight.id} insight={insight} />
      ))}
    </Stack>
  );
};
